import { useCreditData } from "./useCreditData.js";
function useCreditPreviewProgramPayment(vehicleId = "") {
  var _a;
  const creditData = useCreditData(vehicleId);
  return ((_a = creditData == null ? void 0 : creditData.previewProgram) == null ? void 0 : _a.payment) ?? null;
}
export {
  useCreditPreviewProgramPayment
};
